import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { Label } from "../../screens/complaint/Complaint.styled";
import { ButtonContainer } from "../button.primary/button.primary.styled";
import {
  ButtonsContainer,
  InfoContainer,
  TabContainer,
} from "./move-inTabs.styled";
import { BaseProps } from "./interfaces";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Document } from "../Temporary Components/SocialCaseModal.styled";
import MoveInOut, { RegistrationData } from "../../stores/MoveInOutStore";
import ErrorSubscription from "../../stores/ErrorSubscriptionStore";
import User from "../../stores/UserStore";
import General from "../../stores/GeneralStore";
import { ChangeEvent } from "react";
import deviceInfo from "../../utils/deviceInfo";
import { LegacyRef, useEffect, useRef, useState } from "react";
import CONSTANTS, { EMPTY_GUID, PASSWORD_VALIDATION_MESSAGES } from "../../utils/constants";
import Error from "../error";
import moment from "moment";
import axios from "axios";
import { toJS } from "mobx";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import { NotifyError } from "../../utils/ShowError";
import constants from "../../utils/constants";
import trashIcon from "../../assets/trash.svg";
import moveInOutStore from "../../stores/MoveInOutStore";
import { IValidatePassword, IValidatePasswordForRegistration } from "src/interfaces/IValidatePassword";
import { generateUUID } from "../../../src/utils/utilityHelper";
import { encrypt } from "../../utils/crypt";

interface Obj {
  [key: string]: any;
}
interface FileUpload {
  mediaType: string;
  fileName: string;
  buffer: string;
}
interface Props extends BaseProps {
  premise: Obj;
  Submit: (data: any, fileData: any, sendOtp: Boolean) => Promise<void>;
  uaePassSubmit: (data: any, fileData: any, sendOtp: Boolean) => Promise<void>;
  // submitRegisterLogedOutOwner: (data: any) => Promise<void>;today
  submitDoc: (data: any) => Promise<void>;
  // moveIn: (data: any) => Promise<void>;today
  owner: boolean;
  userValidatedDetails: Obj;
  personLargeId: any;
  type: any;
  setNewMobileNum: any;
  bType: string | undefined;
  registerLoader: Boolean;
}
interface OptionalFile{
  id: number,
  name: string
}

const Info = ({
  Submit,
  uaePassSubmit,
  // submitRegisterLogedOutOwner,today
  submitDoc,
  // moveIn,today
  Previous,
  premise,
  owner,
  type,
  bType,
  personLargeId,
  userValidatedDetails,
  registerLoader,
  setNewMobileNum
}: Props) => {


  const customerMessage = useRef<HTMLTextAreaElement | null>(null);
  const [fromUaePass, setFromUaePass] = useState('')
  const nameValue = useRef<HTMLInputElement | null>(null);

  const userNameValue = useRef<HTMLInputElement | null>(null);
  const passwordValue = useRef<HTMLInputElement | null>(null);
  const confirmPasswordValue = useRef<HTMLInputElement | null>(null);

  const vatValue = useRef<HTMLInputElement | null>(null);
  const emailValue = useRef<HTMLInputElement | null>(null);
  const alternateEmailValue = useRef<HTMLInputElement | null>(null);
  const genderValue = useRef<HTMLSelectElement | null>(null);
  const nationalityValue = useRef<HTMLSelectElement | null>(null);
  const languageValue = useRef<HTMLSelectElement | null>(null);
  const favouriteServiceDeliveryChannelValue = useRef<HTMLSelectElement | null>(
    null
  );
  const favouritePaymentChannelValue = useRef<HTMLSelectElement | null>(null);
  const tenancyContractExpiryDateValue = useRef<HTMLInputElement | null>(null);

  const morningValue = useRef<HTMLInputElement | null>(null);
  const afternoonValue = useRef<HTMLInputElement | null>(null);
  const eveningValue = useRef<HTMLInputElement | null>(null);

  const emirateValue = useRef<HTMLSelectElement | null>(null);
  const poBoxValue = useRef<HTMLInputElement | null>(null);

  const dateOfBirthValue = useRef<HTMLInputElement | null>(null);
  const mobileNumberValue = useRef<HTMLInputElement | null>(null);
  
  const [uploadedFiles, setUploadedFiles] = useState<any>({
    "tenantContractFile": null,
    "emiratesIDFile": null,
    "tradeLicenseFile": null
  });
  
  const [optionalUploadedFiles, setOptionalUploadedFiles] = useState<any>([]);
  const [isAcceptTerms, setacceptTerms] = useState(false);
  const [isUserNameUnique, setIsUserNameUnique] = useState(false);
  const [isValidPassword, setIsValidPassword] = useState<any>();
  const [isMatchPassword, setIsMatchPassword] = useState<any>(false);
  const [showEmirates, setShowEmirates] = useState<any>(false);
  const [showTenancy, setShowTenancy] = useState<any>(false);
  const [deviceData, setDeviceData] = useState<any>(null);

  const [fileErrors, setFileErrors] = useState<any>({
    "tenantContractFile": null,
    "emiratesIDFile":null,
    "tradeLicenseFile": null
  });

  var displayUserWithoutEID: Boolean = false;
  var isTenant: Boolean = false;
  var tenancyContractNeeded: Boolean = false;
    const transactionIdRef = useRef<string>(generateUUID());
  useEffect(() => {
    const fetchDeviceInfo = async () => {
      const data = await deviceInfo();
      setDeviceData(data);
    };
    fetchDeviceInfo();
  }, []);
  useEffect(() => {
    const fetchDeviceInfo = async () => {
      const data = await deviceInfo();
      setDeviceData(data);
    };
    fetchDeviceInfo();
  }, []);
  const emiratesIdTenancyDisplay = () => {
    const fromUaePass: any = localStorage.getItem('redirectFrom');
    if (fromUaePass != "uaePassLogin") {
      if (General?.premise?.ownerAccount && General?.premise?.tenantAccount == null) {
        if (owner) {
          setShowEmirates(false);
          setShowTenancy(false);
        } else {
          setShowEmirates(true);
          setShowTenancy(true);
        }
      } else if (General?.premise?.ownerAccount && General?.premise?.tenantAccount) {
        setShowEmirates(false);
        setShowTenancy(false);
      }
    } else {
      if (!owner) {
        isTenant = true;
      }
      if (User.info.reasonCode == 15) {
        displayUserWithoutEID = true;
        setShowEmirates(true);
      } else {
        displayUserWithoutEID = false;
        setShowEmirates(false);
      }
      if (displayUserWithoutEID && isTenant) {
        setShowTenancy(true)
      } else {
        setShowTenancy(false);
      }
    }

  }
  const isObjectEmpty = (objectName: Obj) => {
    return Object.keys(objectName).length === 0;
  };

  const handleAddOptionalDocument = () => {
    const optionalDocs = [...optionalUploadedFiles];
    const maxId = optionalDocs.length > 0 ? Math.max(...optionalDocs.map(doc => doc.id)) : 0;
    const id = maxId + 1;
    const name = "Optional Attachment (" + id + ")";
    const optionalDoc: OptionalFile = { id, name };
    optionalDocs.push(optionalDoc)
    setOptionalUploadedFiles(optionalDocs);
  }

  const handleRemoveOptionalDocument = (id: number) => {
    setOptionalUploadedFiles((prevFiles: OptionalFile[]) => 
      prevFiles.filter(file => file.id !== id)
    );
  }

  // console.log(toJS(premise?.tenantAccount))
  const handleUploadFileChange = async (
    event: ChangeEvent<HTMLInputElement>,
    inputName: string
  ) => {
    const files: FileList | null = event.target.files;
    const fileUploadPromises: Promise<any>[] = [];

    if (files) {
      for (let i = 0; i < files.length; i++) {
        const file: File = files[i];

        // Check if the file is a PDF
        if (file.type === "application/pdf") {
          const promise = new Promise<any>((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
              const buffer = reader.result?.slice(28) as string;
              // const fileName = `${inputName}_${file.name}`;
              const extension = file.name.substring(file.name.lastIndexOf("."));

              const fileName = `${inputName}${extension}`;
              const mediaType = file.type;

              const fileUpload: FileUpload = { mediaType, fileName, buffer };
              resolve({file:fileUpload, key: inputName});
            };
          });

          fileUploadPromises.push(promise);
        } else {
          NotifyError(
            General?.codeLabels["cm_complaint_error"]?.label !== undefined
              ? General?.codeLabels["cm_complaint_error"]?.label
              : "Only PDF files are allowed"
          );
        }
      }
    

      Promise.all(fileUploadPromises)
        .then((file) => {
          // setFieldValue("uploadedFilesData", uploadedFiles);
          // Update Formik field value
          // const uploaded = [...uploadedFiles];
          // files.some((file:any) => {
          // uploaded.push(uploadedFilesfun);
          
          // console.log("uploadedfiles",uploaded)
          setUploadedFiles((prev:any)=>{
            const newFiles = {...prev, [file[0]?.key]: file[0]?.file};
            return newFiles;
          })

          if (file[0]?.key === "tenantContractFile" || (!bType && file[0]?.key === "emiratesIDFile")|| (bType && file[0]?.key === "tradeLicenseFile")) {
            setFileErrors((prev:any)=>{
              const newFiles = {...prev, [file[0]?.key]: false};
              return newFiles;
            });
          }
        })
        .catch((error) => {
          console.error("Error while processing file uploads:", error);
          NotifyError(General?.codeLabels["cm_complaint_error"]?.label);
        });
    }
  };

  const handleFileEvent = (e: any) => {
    const chosenFiles = e.target.files[0];
    handleUpload(chosenFiles);
  };
  
  const handleUpload = (files: any) => {
    const uploaded = [...uploadedFiles];
    // files.some((file:any) => {
    uploaded.push(files);
    // })

    setUploadedFiles(uploaded);
  };

  const readFileAsBuffer = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        const buffer = e?.target?.result;
        resolve(buffer);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsArrayBuffer(file);
    });
  };

  const [invalidUsername, setInvaliusername] = useState(null);
  const validateUserName = async (userName: string) => {
    if (!userName) {
      setInvaliusername(General?.codeLabels['cm_mob_userrqrd']?.label)
      setIsUserNameUnique(false);
      return;
    }
    if (!userName.match(/^[a-zA-Z0-9]+(?:_[a-zA-Z0-9]+)*$/)) {
      setIsUserNameUnique(false)
      setInvaliusername(General?.codeLabels["cm_userName_invalid"]?.label ? General?.codeLabels["cm_userName_invalid"]?.label : "Invalid Username")
    }
    setInvaliusername(null)
    MoveInOut.validateUserName({
      errorId: "validateUseName",
      data: userName,
    }).then((res) => {
      if (res?.result?.status == "S") {
        setIsUserNameUnique(true)
      } else if (res?.result?.status == "D") {
        const personId = owner ? premise?.ownerAccount ? premise?.ownerAccount.personID : userValidatedDetails?.personId : premise?.tenantAccount ? premise?.tenantAccount.personID : userValidatedDetails?.personId;
        if (personId == res?.result?.personId) {
          setIsUserNameUnique(false)
        } else {
          setIsUserNameUnique(true)
        }
      } else {
        setIsUserNameUnique(false)
      }
    }
    );
  };
  
  const validatePassword = async (pass?: string): Promise<boolean> => {
    const userName = userNameValue.current?.value ?? null;

    if (!pass) {
      setIsValidPassword(General?.codeLabels?.["cm_enterpassword"]?.label ?? "Please enter a password to continue.");
      return false;
    }
  
    if (pass.length < 8) {
      setIsValidPassword(General?.codeLabels?.["cm_mob_passmin"]?.label ?? "The password must be at least 8 characters long.");
      return false;
    }
    
    const encryptedPassword = encrypt(pass);
    const encyptedUserName = userName ? encrypt(userName) : ""; 
  
    // const payload: IValidatePassword = { password: encryptedPassword, username: encyptedUserName };
    const payload:IValidatePasswordForRegistration = {
      name:nameValue.current?.value??"",
      email: emailValue.current?.value??"",
      password:pass,
      userName: userNameValue.current?.value??"",
      mobileNumber: mobileNumberValue.current?.value??"",
      alternateEmail: alternateEmailValue.current?.value??""
    }
  
    // Check if the password is blacklisted
    const { isBlackListed,passwordPolicySatisfied } = await moveInOutStore.validatePasswordForRegistration({ errorId: "", data: payload });
  
    if (isBlackListed) {
        setIsValidPassword(General?.codeLabels?.["cm_password_blacklisted"]?.label || PASSWORD_VALIDATION_MESSAGES.blacklisted);
        return false;
    }
    if(!passwordPolicySatisfied){
      setIsValidPassword(General?.codeLabels?.["cm_password_security_validation"]?.label || PASSWORD_VALIDATION_MESSAGES.blacklisted);
        return false;

    }
  
    const name = nameValue.current?.value?.toLowerCase() ?? "";
    const mobileNumber = mobileNumberValue.current?.value ?? "";
    const email = emailValue.current?.value?.toLowerCase() ?? "";
    const alternateEmail = alternateEmailValue.current?.value?.toLowerCase() ?? "";
  
    const lowerPass = pass.toLowerCase();
  
    // Split name into words and filter out initials (<=1 char)
    const nameParts = name.split(/\s+/).filter(part => part.length > 1);
    const userNameParts = userName ? userName.split(/\s+/).filter(part => part.length > 1) : [];
  
    let userData = [...nameParts, email, mobileNumber, alternateEmail];

    if(userNameParts?.length > 0){
      userData = [...userData, ...userNameParts]
    }
    
    // for (const data of userData) {
    //   if (data && lowerPass.includes(data)) {
    //     setIsValidPassword(General?.codeLabels?.["cm_password_security_validation"]?.label ?? "Your password cannot contain personal information.");
    //     return false;
    //   }
    // }
  
    setIsValidPassword("");
    return true;
  };
  
  
  const validateConfirmPassword = (pass: any) => {
    const password = passwordValue.current?.value ?? null;
    const cPassword = confirmPasswordValue.current?.value ?? null;
    if (!(password == cPassword)) {
      setIsMatchPassword(General?.codeLabels["cm_cpasserror"]?.label ? General?.codeLabels["cm_cpasserror"]?.label : "The Password And Confirmation Password Do Not Match.");
      return false;
    } else {
      setIsMatchPassword("");
      return true
    }
  };

  const [nationalityValueFromConst, setNationalityValue] = useState<any>();
  const handleNationalityChange = (e: any) => {
    const filterNationality: any = General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? CONSTANTS.countriesAr?.filter((nationality) => nationality?.key == e?.target?.value) : General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "HIN" ? CONSTANTS.countriesHi?.filter((nationality) => nationality?.key == e?.target?.value) : CONSTANTS.countriesEn?.filter((nationality) => nationality?.key == e?.target?.value);
    setNationalityValue(filterNationality[0]?.value)
  }
  const [prefferedCommunicationEr, setPrefferedCommunicationErr] = useState(false)
  const validate = () => {
    const userName = userNameValue.current?.value ?? null;
    const password = passwordValue.current?.value ?? null;
    const cPassword = confirmPasswordValue.current?.value ?? null;

    
    if(uploadedFiles["tenantContractFile"] == null && showTenancy){
      setFileErrors((prev:any)=>{
        const newFiles = {...prev, ["tenantContractFile"]: true};
        return newFiles;
      });
    }

    if(uploadedFiles["emiratesIDFile"] == null &&  showEmirates && !bType ){
      setFileErrors((prev:any)=>{
        const newFiles = {...prev, ["emiratesIDFile"]: true};
        return newFiles;
      });
    }
    if(uploadedFiles["tradeLicenseFile"] == null && bType ){
      setFileErrors((prev:any)=>{
        const newFiles = {...prev, ["tradeLicenseFile"]: true};
        return newFiles;
      });

    }

    if(!userName){
      setInvaliusername(General?.codeLabels['cm_mob_userrqrd']?.label)
      setIsUserNameUnique(false);
    }
    if(!password){
      setIsValidPassword(General?.codeLabels["cm_enterpassword"]?.label !== undefined ? General?.codeLabels["cm_enterpassword"]?.label : "Please enter password to continue.");
    }
    if(!cPassword){
      setIsMatchPassword(General?.codeLabels["cm_cpasserror"]?.label ? General?.codeLabels["cm_cpasserror"]?.label : "The Password And Confirmation Password Do Not Match.");
    }
  }
  const handleSubmit = (values: {
    dateOfBirth: string;
    [key: string]: any;
  }) => {
    ErrorSubscription.unSubscribeAll();
    setPrefferedCommunicationErr(false);
    let languageVal = languageValue.current?.value ?? null;

    // map Hindi → English
    if (languageVal?.startsWith("HIN")) {
    languageVal = "ENG-English";
    }
    const userName = userNameValue.current?.value ?? null;
    const password = passwordValue.current?.value ?? null;
    const cPassword = confirmPasswordValue.current?.value ?? null;
    const vatRegNO = vatValue.current?.value ?? null;
    const name = nameValue.current?.value ?? null;
    const email: any = emailValue.current?.value ?? null;
    const alternateEmail = alternateEmailValue.current?.value ?? null;
    const gender = genderValue.current?.value ?? null;
    const nationality = nationalityValue.current?.value ?? null;
    const language = languageVal ?? null;
    const favouriteServiceDeliveryChannel =
      favouriteServiceDeliveryChannelValue.current?.value ?? null;
    const favouritePaymentChannel =
      favouritePaymentChannelValue.current?.value ?? null;
    const tenancyContract =
      tenancyContractExpiryDateValue.current?.value ?? null;

    const morning = morningValue.current?.value ?? null;
    const afternoon = afternoonValue.current?.value ?? null;
    const evening = eveningValue.current?.value ?? null;

    const emirate = emirateValue.current?.value ?? null;
    const poBox = poBoxValue.current?.value ?? null;

    const dateOfBirth = values?.dateOfBirth;
    const mobileNumber = mobileNumberValue.current?.value ?? null;
    setNewMobileNum(mobileNumber)
    var filterNationality: any = General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA"
      ? CONSTANTS.countriesAr?.filter((nationalityConst) => nationalityConst?.key == nationality)
      : General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "HIN"
        ? CONSTANTS.countriesHi?.filter((nationalityConst) => nationalityConst?.key == nationality)
        : CONSTANTS.countriesEn?.filter((nationalityConst) => nationalityConst?.key == nationality);


    if (!morning && !afternoon && !evening) {
      setPrefferedCommunicationErr(true);
      return;
    }


    if (showTenancy || showEmirates) {
      const requiredIdFile = bType ? "tradeLicenseFile" : "emiratesIDFile";
      if (uploadedFiles[requiredIdFile] == null || uploadedFiles["tenantContractFile"] == true) {
        NotifyError(General?.codeLabels['cm_missingfileerr']?.label)
        return;
      }
    }
    if (true) {

      var sendData;

      if (fromUaePass != "uaePassLogin") {
        sendData = {
          platform: "Web",
          type: owner ? "" : premise?.tenantAccount ? "" : type, // ok
          id: owner ? "" : personLargeId ? personLargeId : '', // ok
          // personId: owner
          //   ? premise?.ownerAccount.personID
          //   : User?.info?.personId
          //   ? User?.profile?.personId
          //   : !isObjectEmpty(userValidatedDetails)
          //   ? userValidatedDetails?.personId
          //   : "", // ok
          personId: owner ? premise?.ownerAccount ? premise?.ownerAccount.personID : userValidatedDetails?.personId : premise?.tenantAccount ? premise?.tenantAccount.personID : userValidatedDetails?.personId,
          vatRegNO: vatRegNO, // ok
          isUAEPASSEnabled: User.profile.isUAEPASSEnabled,
          poBox,
          emirate,
          name:name?.replace(/,/g, " "), // ok
          username: userName, //ok
          password: password, // ok
          premiseId: premise.premiseId, // ok
          email, // ok
          mobileNumber, // ok
          dateOfBirth, //ok
          gender: gender // ok
            ? {
              key: gender,
              value: gender == "M" ? "Male" : "Female",
            }
            : null,
          language: language // ok
            ? {
              key: language.split("-")[0],
              value: language.split("-")[1],
            }
            : null,
          nationality: nationality // ok
            ? {
              key: nationality.split("-")[0],
              value: filterNationality[0]?.value,
            }
            : null,
          favouriteServiceDeliveryChannel: favouriteServiceDeliveryChannel //ok
            ? {
              key: favouriteServiceDeliveryChannel.split("-")[0],
              value: favouriteServiceDeliveryChannel.split("-")[1],
            }
            : null,
          favouritePaymentChannel: favouritePaymentChannel // ok
            ? {
              key: favouritePaymentChannel.split("-")[0],
              value: favouritePaymentChannel.split("-")[1],
            }
            : null,

            morning: morning === "true" ? true : false, // ensures boolean true only if checked
            afternoon: afternoon === "true" ? true : false,
            evening: evening === "true" ? true : false,
          alternateEmail,
          tenancyContract: tenancyContract ? tenancyContract : "", //ok
          businessType: type == "I" ? "UNI" : bType, //ok
          accountNumber: owner ? premise?.ownerAccount ? premise?.ownerAccount?.accountNumber : "" : premise?.tenantAccount ? premise?.tenantAccount.accountNumber : "", // ok
          // accountNumber: premise?.ownerAccount?.accountNumber, // ok
          registrationType: owner ? "Default Account" : "UoS Account", //ok
          // existingMobileNumber: General?.otpUserData?.mobileNumber?General?.otpUserData?.mobileNumber?.replace(/-/g,''):null,
          existingMobileNumber: null,
          deviceVersion: deviceData.device,
          location: deviceData.ip,
          browser: deviceData.platform,
          enableConsent: true,
          modeOfConsent: 'CSS_Registration',
          // existingMobileNumber: owner // ok
          //   ? premise?.ownerAccount.phoneNumber
          //   : User?.profile?.personId
          //   ? User.profile.mobileNumber
          //   : !isObjectEmpty(userValidatedDetails)
          //   ? userValidatedDetails.mobileNumber
          //   : null,
        };
      } else {
        sendData = {
          platform: "Web", //ok
          type: owner ? "" : "I", // ok
          uuid: User.uaePassDetails?.uuid ? User?.uaePassDetails?.uuid : null,//ok
          emiratesId: User.uaePassDetails.emiratesId
            ? User.uaePassDetails.emiratesId
            : null,//OK
          reasonCode: User.info.reasonCode,
          uaePassEmail: User.uaePassDetails.email,//OK
          id: User.uaePassDetails.idn ? User.uaePassDetails.idn : User.uaePassDetails.emiratesId, // ok
          premiseId: premise?.premiseId,//ok
          uaePassMobileNumber: User.uaePassDetails.mobile?.replace("971", "0"),//ok
          premiseMobile: "",//ok
          premiseEmail: "",//ok

          personId: owner ? premise?.ownerAccount ? premise?.ownerAccount.personID : userValidatedDetails?.personId : premise?.tenantAccount ? premise?.tenantAccount.personID : userValidatedDetails?.personId,
          vatRegNO: vatRegNO, // ok
          isUAEPASSEnabled: true,//ok
          // poBox,check again
          // emirate,
          username: "",//ok
          password: "",//ok
          name: name?.replace(/,/g, " "), // ok
          email, // ok
          mobileNumber: mobileNumber?.replace("971", "0"), // ok
          dateOfBirth, //ok
          gender: gender // ok
            ? {
              key: gender,
              value: gender == "M" ? "Male" : "Female",
            }
            : null,
          language: language // ok
            ? {
              key: language.split("-")[0],
              value: language.split("-")[1],
            }
            : null,
          nationality: nationality // ok
            ? {
              key: nationality.split("-")[0],
              value: nationalityValueFromConst ? nationalityValueFromConst : filterNationality[0]?.value,
            }
            : null,
          favouriteServiceDeliveryChannel: favouriteServiceDeliveryChannel //ok
            ? {
              key: favouriteServiceDeliveryChannel.split("-")[0],
              value: favouriteServiceDeliveryChannel.split("-")[1],
            }
            : null,
          favouritePaymentChannel: favouritePaymentChannel // ok
            ? {
              key: favouritePaymentChannel.split("-")[0],
              value: favouritePaymentChannel.split("-")[1],
            }
            : null,

          morning: morning === "true" ? true : false, // ensures boolean true only if checked
          afternoon: afternoon === "true" ? true : false,
          evening: evening === "true" ? true : false,
          alternateEmail,//ok
          tenancyContract: tenancyContract ? tenancyContract : "", //ok
          accountNumber: owner ? premise?.ownerAccount ? premise?.ownerAccount?.accountNumber : "" : premise?.tenantAccount ? premise?.tenantAccount.accountNumber : "", //ok
          registraionType: owner ? "Default Account" : "UoS Account", //ok
          deviceVersion: deviceData.device,
          location: deviceData.ip,
          browser: deviceData.platform,
          enableConsent: true,
          modeOfConsent: 'CSS_Registration',
          // existingMobileNumber: General?.otpUserData?.mobileNumber?General?.otpUserData?.mobileNumber?.replace('971','0'): null
        };
      }
      var filearr: any = [];
      // Convert uploaded files object to array of file uploads
      Object.entries(uploadedFiles).forEach(([_, file]) => {
        if (file) {
          const fileUpload = {
            mediaType: (file as any).mediaType,
            fileName: (file as any).fileName, 
            buffer: (file as any).buffer
          };
          filearr.push(fileUpload);
        }
      });
      const fileData = {
        // customerMessage: customerMessage.current?.value,
        files: filearr,
      };
      if (fromUaePass != "uaePassLogin") {
        const sendOtp =mobileNumber == General?.otpUserData?.mobileNumber?.replace(/-/g, '')?.replace('971', '0') ? false : true;
        Submit({transactionId: EMPTY_GUID, ...sendData}, fileData, sendOtp);
      } else {
        uaePassSubmit(sendData, fileData, mobileNumber == General?.otpUserData?.mobileNumber?.replace(/-/g, '')?.replace('971', '0') ? false : true)
      }
    } else {
      ErrorSubscription.subscribe({
        id: "moveInError",
        message:
          "Invalid Form. Please make sure to submit all required documents.",
      });
    }
  };
  function convertToISODate(inputDate: string): string {
    const parts = inputDate?.split('-');
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = (monthNames?.indexOf(parts[1]) + 1)?.toString()?.padStart(2, '0');
    const day = parts[0];
    const year = parts[2];

    const isoDateString = `${year}-${month}-${day}T00:00:00.000Z`;
    return isoDateString?.substring(0, 10);
  }
  const defaultDate = convertToISODate(General?.otpUserData?.dateOfBirth ? General?.otpUserData?.dateOfBirth : '');
  const defaultDateContract = convertToISODate(General?.otpUserData?.tenancyContractExpiryDate ? General?.otpUserData?.tenancyContractExpiryDate : '');
  // Example usage:
  const inputDate = "13-Sep-2022";
  const isoDate = convertToISODate(inputDate);
  useEffect(() => {
    const fromUaePass: any = localStorage.getItem('redirectFrom');
    setFromUaePass(fromUaePass)
    emiratesIdTenancyDisplay()
  }, [])
  useEffect(() => {
  }, [isUserNameUnique])
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;

  const getValidationSchema = (owner: any) => {
    let schemaFields = {
      name: Yup.string()
      .required(General?.codeLabels["cm_name_mand"]?.label),
      // Accept all special characters except numbers
      // .matches(/^[^\d]+$/, General?.codeLabels["cm_invalid_name"]?.label ? General?.codeLabels["cm_invalid_name"]?.label : "Invalid name"),
    dateOfBirth: Yup.string() // We use string first to catch the raw text input
  .required(General?.codeLabels["cm_mob_doberr"]?.label || "Date Of Birth Is Mandatory")
  .test("is-valid-and-recent", General?.codeLabels["cm_valid_year_required"]?.label, function (value) {
    if (!value) return false;

    // type="date" always returns "YYYY-MM-DD" to Yup
    const parts = value.split("-");
    const year = parseInt(parts[0], 10);

    // 1. Check if the year is actually 4 digits (stops 01, 001, etc.)
    const isFourDigits = parts[0].length === 4;

    // 2. Check if the year is within a human range
    const isRecentEnough = year >= 1900;

    // 3. Check if it's not in the future
    const isNotFuture = new Date(value) <= new Date();

    return isFourDigits && isRecentEnough && isNotFuture;
  })
      ,
      gender: Yup.string().required(General?.codeLabels["cm_mob_gendrerr"]?.label ? General?.codeLabels["cm_mob_gendrerr"]?.label : "Please Select Gender"),
      nationality: Yup.string().required(General?.codeLabels["cm_naterr"]?.label ? General?.codeLabels["cm_naterr"]?.label : "Please Select Nationality"),
      language: Yup.string().required(General?.codeLabels["cm_choose_lang"]?.label ? General?.codeLabels["cm_choose_lang"]?.label : "Please Select Language"),
      emirate: Yup.string().required(General?.codeLabels["cm_select_emirates"]?.label ? General?.codeLabels["cm_select_emirates"]?.label : "Please Select Emirate"),
      preferredDeliveryChannel: Yup.string().required(General?.codeLabels["cm_prefferes_validation"]?.label ? General?.codeLabels["cm_prefferes_validation"]?.label : "Please Select Preferred Service Delivery Channel"),
      prefferedPaymentChannel: Yup.string().required(General?.codeLabels["cm_preffered_payment_validation"]?.label ? General?.codeLabels["cm_preffered_payment_validation"]?.label : "Please Select Preferred Payment Channe"),
      premiseId: Yup.string().required(General?.codeLabels["cm_premise_mand"]?.label ? General?.codeLabels["cm_premise_mand"]?.label : "premiseId is required").min(10, General?.codeLabels["cm_mob_seweragemin"]?.label).max(10, General?.codeLabels["cm_mob_seweragemax"]?.label),
      email: Yup.string().matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, General.codeLabels['cm_emailerr']?.label).required(General?.codeLabels["cm_email_rqd"]?.label),
      alternateEmail: Yup.string().matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, General.codeLabels['cm_emailerr']?.label),
      mobileNumber: Yup.string().matches(/^05[0-9]{8}$/, General?.codeLabels["cm_ivalid_mobile"]?.label ? General?.codeLabels["cm_ivalid_mobile"]?.label : "Invalid mobile number").required(General?.codeLabels["cm_mobilenumberreqerr"]?.label ? General?.codeLabels["cm_mobilenumberreqerr"]?.label : "Mobile number is required"),
      poBoxValue: Yup.string().matches(/^[0-9]+$/, General?.codeLabels["cm_invalidpobox"]?.label).required(General?.codeLabels["cm_man_pobox"]?.label ? General?.codeLabels["cm_man_pobox"]?.label : "Po Box number is required"),
      vatValue: Yup.string()
        .matches(
        /^1.*3$/,
        General?.codeLabels["cm_inalid_vat"]?.label || "VAT must start with 1 and end with 3"
      )
        .matches(/^[0-9]+$/, General?.codeLabels["cm_invalid_vat"]?.label ? General?.codeLabels["cm_invalid_vat"]?.label : "Invalid Vat Registration No").min(15, General?.codeLabels["cm_mob_vatmin"]?.label).max(15, General?.codeLabels["cm_mob_vatmax"]?.label),
      tenancyDate: Yup.string(),
      morningValue: Yup.boolean().test(
        'at-least-one-true',
        'You must select at least one preferred time of communication',
        function (value) {
          return this.parent.morningValue || this.parent.afternoonValue || this.parent.eveningValue;
        }
      ),
      afternoonValue: Yup.boolean().test(
        'at-least-one-true',
        'You must select at least one preferred time of communication',
        function (value) {
          return this.parent.morningValue || this.parent.afternoonValue || this.parent.eveningValue;
        }
      ),
      eveningValue: Yup.boolean().test(
        'at-least-one-true',
        'You must select at least one preferred time of communication',
        function (value) {
          return this.parent.morningValue || this.parent.afternoonValue || this.parent.eveningValue;
        }
      ),
    };

    if (!owner) {
      schemaFields.tenancyDate = Yup.string().required(General?.codeLabels["cm_mob_contexpdterr"]?.label ? General?.codeLabels["cm_mob_contexpdterr"]?.label : "Tenancy Contract Expiry Date Is Mandatory");
    }

    return Yup.object().shape(schemaFields);
  };

  const validationSchema = getValidationSchema(owner);

  // const validationSchema = Yup.object().shape({


  // });


  return (
    <>
      <TabContainer>
        <Error id="moveInError" />
        <h3
          style={{
            fontFamily: "Segoe UI",
            fontStyle: "normal",
            fontWeight: "700",
            fontSize: `${1.5 * General.accessibility.fontSize}rem`,
            lineHeight: "32px",
            color: General.contrast.contrastColor
              ? General.contrast.contrastColor
              : General?.ColorAss,
            marginTop: "2rem",
          }}
        >
          {General?.codeLabels["cm_registration_user_information"]?.label !==
          undefined
            ? General?.codeLabels["cm_registration_user_information"]?.label
            : "User Information"}
        </h3>
        <Formik
          initialValues={{
            name: General?.otpUserData?.name,
            email: General?.otpUserData?.email
              ? General?.otpUserData?.email
              : User.uaePassDetails.email
              ? User.uaePassDetails.email
              : "",
            mobileNumber: General?.otpUserData?.mobileNumber
              ?.replace(/-/g, "")
              ?.replace("971", "0"),
            premiseId: premise?.premiseId ? premise?.premiseId : "",
            premiseDetails: premise.premiseDetails,
            premiseUsage: premise?.premiseUsage,
            vatValue: "",
            poBoxValue: General?.otpUserData?.city,
            userNameValue: "",
            dateOfBirth: defaultDate !== "undefined-" ? defaultDate : "",
            gender: General?.otpUserData?.gender?.key
              ? General?.otpUserData?.gender?.key
              : "",
            nationality: General?.otpUserData?.nationality?.key
              ? General?.otpUserData?.nationality?.key
              : type === "B" ? "ARE" : "",
            language: "ENG-English",
            emirate: General?.otpUserData?.state
              ? General?.otpUserData?.state
              : "",
            alternateEmail: General?.otpUserData?.alternateEmail
              ? General?.otpUserData?.alternateEmail
              : "",
            preferredDeliveryChannel: General?.otpUserData
            ?.favouriteServiceDeliveryChannel?.key  && General?.otpUserData?.favouriteServiceDeliveryChannel?.value
              ? General?.otpUserData?.favouriteServiceDeliveryChannel?.key +
                "-" +
                General?.otpUserData?.favouriteServiceDeliveryChannel.value
              : "",
            prefferedPaymentChannel:  General?.otpUserData
            ?.favouritePaymentChannel?.key && General?.otpUserData
            ?.favouritePaymentChannel?.value
              ? General?.otpUserData?.favouritePaymentChannel?.key +
                "-" +
                General?.otpUserData?.favouritePaymentChannel.value
              : "",
            tenancyDate:
              defaultDateContract !== "undefined-" ? defaultDateContract : "",
            morningValue: General?.otpUserData?.morning || false,
            afternoonValue: General?.otpUserData?.afternoon || false,
            eveningValue: General?.otpUserData?.evening || false,
            password: "",
            conformPassword: "",
            toggle: false,
            customMessage: "",
            emiratedIdUaePass: User.uaePassDetails.emiratesId
              ? User.uaePassDetails.emiratesId
              : "",
            preferredTimeOfCommunication: [],

            // Add more initial values as needed
          }}
          validationSchema={validationSchema}
          onSubmit={async (values, { setSubmitting }) => {
            setSubmitting(false);

            if (fromUaePass == "uaePassLogin") {
              handleSubmit(values);
              return;
            }
            if (
              fromUaePass != "uaePassLogin" &&
              await validatePassword(passwordValue?.current?.value) &&
              validateConfirmPassword(
                confirmPasswordValue.current?.value && values?.userNameValue
              )
            ) {
              handleSubmit(values);
              return;
            } else {
              validateConfirmPassword(confirmPasswordValue.current?.value);
              validateUserName(values?.userNameValue);
            }
          }}
        >
          {({ isSubmitting, values, errors, touched, setFieldValue }) => (
            <Form>
              <InfoContainer
                style={{
                  gridTemplateColumns: General?.isLargeScreen ? "" : "1fr",
                }}
              >
                <Label
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "1rem",
                  }}
                >
                  {General?.codeLabels["cm_dname"]?.label !== undefined
                    ? General?.codeLabels["cm_dname"]?.label
                    : "Name "}
                  <Field
                    type="text"
                    name="name"
                    disabled={
                      owner
                        ? General?.otpUserData?.name
                          ? true
                          : false
                        : General?.otpUserData?.name
                        ? true
                        : false
                    }
                    style={{
                      background: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : "#E5EFF2",
                      color: General.contrast.contrastBackground
                        ? General.contrast.contrastBackground
                        : General?.ColorAss,
                    }}
                    innerRef={nameValue} // Use innerRef to get a reference to the input
                  />
                  <div style={{ height: "0.5rem" }}>
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </Label>
                {/* Repeat for other input fields */}
                <Label
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "1rem",
                  }}
                >
                  {/* badak traje3onnn ma TENSA */}

                  {General?.codeLabels["cm_primaryemail"]?.label !== undefined
                    ? General?.codeLabels["cm_primaryemail"]?.label
                    : "Primary Email Address"}
                  <Field
                    innerRef={emailValue}
                    type="email"
                    name="email"
                    disabled={
                      owner
                        ? General?.otpUserData?.email
                          ? true
                          : false
                        : General?.otpUserData?.email
                        ? true
                        : false
                    }
                    style={{
                      background: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : "#E5EFF2",
                      color: General.contrast.contrastBackground
                        ? General.contrast.contrastBackground
                        : General?.ColorAss,
                    }}
                  />
                  <div style={{ height: "0.5rem" }}>
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </Label>
                <Label
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                  }}
                >
                  {General?.codeLabels["cm_mobilenumber"]?.label !== undefined
                    ? General?.codeLabels["cm_mobilenumber"]?.label
                    : "Mobile Number*(05X-Xxx-Xxxx)"}
                  <Field
                    style={{
                      background: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : "#E5EFF2",
                      color: General.contrast.contrastBackground
                        ? General.contrast.contrastBackground
                        : General?.ColorAss,
                    }}
                    innerRef={mobileNumberValue}
                    type="text"
                    name="mobileNumber"
                  />
                  <div style={{ height: "0.5rem" }}>
                    <ErrorMessage
                      name="mobileNumber"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </Label>
                <Label
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                  }}
                >
                  {/* badak traje3onnn ma TENSA */}
                  {General?.codeLabels["cm_premiseid"]?.label !== undefined
                    ? General?.codeLabels["cm_premiseid"]?.label
                    : "Sewerage Number"}{" "}
                  <Field
                    type="number"
                    name="premiseId"
                    defaultValue={premise.premiseId}
                    disabled={premise?.premiseId ? true : false}
                    style={{
                      background: premise?.premiseId
                        ? General.contrast.contrastColor
                          ? General.contrast.contrastColor
                          : "#E5EFF2"
                        : "",
                      color: General.contrast.contrastBackground
                        ? General.contrast.contrastBackground
                        : General?.ColorAss,
                    }}
                  />
                  <div style={{ height: "0.5rem" }}>
                    <ErrorMessage
                      name="premiseId"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </Label>
                <Label
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                  }}
                >
                  {General?.codeLabels["cm_propertydet"]?.label !== undefined
                    ? General?.codeLabels["cm_propertydet"]?.label
                    : "Property Details"}
                  <Field
                    type="text"
                    name="premiseDetails"
                    disabled
                    style={{
                      background: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : "#E5EFF2",
                      color: General.contrast.contrastBackground
                        ? General.contrast.contrastBackground
                        : General?.ColorAss,
                    }}
                  />
                  <div style={{ height: "0.5rem" }}></div>
                </Label>
                <Label
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                  }}
                >
                  {General?.codeLabels["cm_propertyusage"]?.label !== undefined
                    ? General?.codeLabels["cm_propertyusage"]?.label
                    : "Property Usage"}{" "}
                  <Field
                    type="text"
                    name="premiseUsage"
                    defaultValue={premise.premiseUsage}
                    disabled={premise?.premiseUsage ? true : false}
                    style={{
                      background: premise?.premiseUsage
                        ? General.contrast.contrastColor
                          ? General.contrast.contrastColor
                          : "#E5EFF2"
                        : "",
                      color: General.contrast.contrastBackground
                        ? General.contrast.contrastBackground
                        : General?.ColorAss,
                    }}
                  />
                  <div style={{ height: "0.5rem" }}></div>
                </Label>
                <Label
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                  }}
                >
                  {General?.codeLabels["cm_registration_vat_register"]
                    ?.label !== undefined
                    ? General?.codeLabels["cm_registration_vat_register"]?.label
                    : "VAT Registration Number (TRN)"}
                  <Field
                    innerRef={vatValue}
                    type="number"
                    name="vatValue"
                    placeholder={
                      General?.codeLabels["cm_registration_vat_register"]
                        ?.label !== undefined
                        ? General?.codeLabels["cm_registration_vat_register"]
                            ?.label
                        : "VAT Registration Number (TRN)"
                    }
                    style={{
                      background: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : "#E5EFF2",
                      color: General.contrast.contrastBackground
                        ? General.contrast.contrastBackground
                        : General?.ColorAss,
                    }}
                  />
                  <div style={{ height: "0.5rem" }}>
                    <ErrorMessage
                      name="vatValue"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </Label>
                {fromUaePass && (
                  <Label
                    style={{
                      color: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : General?.ColorAss,
                      fontFamily: "Segoe UI",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      lineHeight: "16px",
                      gap: "0.5rem",
                    }}
                  >
                    {General?.codeLabels["cm_emirate_id"]?.label !== undefined
                      ? General?.codeLabels["cm_emirate_id"]?.label
                      : "Emirates ID Number"}
                    <Field
                      type="number"
                      readOnly={true}
                      name="emiratedIdUaePass"
                      style={{
                        background: premise?.premiseUsage
                          ? General.contrast.contrastColor
                            ? General.contrast.contrastColor
                            : "#E5EFF2"
                          : "",
                        color: General.contrast.contrastBackground
                          ? General.contrast.contrastBackground
                          : General?.ColorAss,
                      }}
                      placeholder={
                        General?.codeLabels["cm_emirate_id"]?.label !==
                        undefined
                          ? General?.codeLabels["cm_emirate_id"]?.label
                          : "Emirates ID Number"
                      }
                    />
                    <div style={{ height: "0.5rem" }}></div>
                  </Label>
                )}
              </InfoContainer>
              <InfoContainer>
                <h3
                  style={{
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: "25px",
                    lineHeight: "32px",
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    marginTop: "2rem",
                  }}
                >
                  {General?.codeLabels["cm_personal_information"]?.label}
                </h3>
              </InfoContainer>
              <InfoContainer
                style={{
                  gridTemplateColumns: General?.isLargeScreen ? "" : "1fr",
                }}
              >
                <Label
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "1rem",
                  }}
                >
                  {General?.codeLabels["cm_dob"]?.label !== undefined
                    ? General?.codeLabels["cm_dob"]?.label
                    : "Date Of Birth"}{" "}
                  *
                  <Field
                    type="date"
                    placeholder="dd/mm/yyyy"
                    min="1900-01-01" // Prevents selecting ancient dates in the UI
                    max={new Date().toISOString().split("T")[0]}
                    innerRef={dateOfBirthValue}
                    name={"dateOfBirth"}
                    style={{
                      background: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : "#E5EFF2",
                      color: General.contrast.contrastBackground
                        ? General.contrast.contrastBackground
                        : General?.ColorAss,
                    }}
                  />
                  <div style={{ height: "0.5rem" }}>
                    <ErrorMessage
                      name="dateOfBirth"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </Label>
                <Label
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                  }}
                >
                  {General?.codeLabels["cm_gender"]?.label !== undefined
                    ? General?.codeLabels["cm_gender"]?.label
                    : "Gender"}
                  *
                  <Field
                    as="select"
                    name="gender"
                    innerRef={genderValue}
                    style={{
                      background: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : "#E5EFF2",
                      color: General.contrast.contrastBackground
                        ? General.contrast.contrastBackground
                        : General?.ColorAss,
                    }}
                  >
                    <option value={""}>
                      {General?.codeLabels["cm_mob_select"]?.label !== undefined
                        ? General?.codeLabels["cm_mob_select"]?.label
                        : "Select"}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.gender?.key == "M" ||
                        General?.otpUserData?.gender == "Male"
                          ? true
                          : false
                      }
                      value="M"
                    >
                      {General?.codeLabels["cm_male"]?.label !== undefined
                        ? General?.codeLabels["cm_male"]?.label
                        : "Male"}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.gender?.key == "F" ||
                        General?.otpUserData?.gender == "Female"
                          ? true
                          : false
                      }
                      value="F"
                    >
                      {General?.codeLabels["cm_female"]?.label !== undefined
                        ? General?.codeLabels["cm_female"]?.label
                        : "Female"}
                    </option>
                  </Field>
                  <div style={{ height: "0.5rem" }}>
                    <ErrorMessage
                      name="gender"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </Label>
                <Label
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                  }}
                >
                  {General?.codeLabels["cm_nationality"]?.label !== undefined
                    ? General?.codeLabels["cm_nationality"]?.label
                    : "Nationality"}
                  *
                  <Field
                    as="select"
                    name="nationality"
                    innerRef={nationalityValue}
                    style={{
                      background: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : "#E5EFF2",
                      color: General.contrast.contrastBackground
                        ? General.contrast.contrastBackground
                        : General?.ColorAss,
                    }}
                    disabled={type === "B" ? true : false}
                  >
                    <option value={""}>
                      {General?.codeLabels["cm_mob_select"]?.label !== undefined
                        ? General?.codeLabels["cm_mob_select"]?.label
                        : "Select"}
                    </option>
                    {General?.codeLabels["cm_pdc_paymentaccounts"]
                      ?.languageCode == "ARA"
                      ? CONSTANTS.countriesAr.map((nationality) => {
                          return (
                            <option
                              value={nationality?.key}
                              selected={
                                General?.otpUserData?.nationality?.key ==
                                nationality?.key
                                  ? true
                                  : false
                              }
                            >
                              {nationality?.value}
                            </option>
                          );
                        })
                      : General?.codeLabels["cm_pdc_paymentaccounts"]
                          ?.languageCode == "HIN"
                      ? CONSTANTS.countriesHi.map((nationality) => {
                          return (
                            <option
                              value={nationality?.key}
                              selected={
                                General?.otpUserData?.nationality?.key ==
                                nationality?.key
                                  ? true
                                  : false
                              }
                            >
                              {nationality?.value}
                            </option>
                          );
                        })
                      : CONSTANTS.countriesEn.map((nationality) => {
                          return (
                            <option
                              value={nationality?.key}
                              selected={
                                General?.otpUserData?.nationality?.key ==
                                nationality?.key
                                  ? true
                                  : false
                              }
                            >
                              {nationality?.value}
                            </option>
                          );
                        })}
                  </Field>
                  <div style={{ height: "0.5rem" }}>
                    <ErrorMessage
                      name="nationality"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </Label>
                <Label
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                  }}
                >
                  {General?.codeLabels["cm_preffered_language"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_preffered_language"]?.label
                    : "Preferred Language"}
                  *
                  <Field
                    as="select"
                    name="language"
                    innerRef={languageValue}
                    style={{
                      background: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : "#E5EFF2",
                      color: General.contrast.contrastBackground
                        ? General.contrast.contrastBackground
                        : General?.ColorAss,
                    }}
                  >
                    <option value={""}>
                      {General?.codeLabels["cm_mob_select"]?.label !== undefined
                        ? General?.codeLabels["cm_mob_select"]?.label
                        : "Select"}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.language?.key == "ENG"
                          ? true
                          : false
                      }
                      value="ENG-English"
                    >
                      {General?.codeLabels["cm_eng"]?.label}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.language?.key == "HIN"
                          ? true
                          : false
                      }
                      value="HIN-Hindi"
                    >
                      {General?.codeLabels["cm_hin"]?.label}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.language?.key == "ARA"
                          ? true
                          : false
                      }
                      value="ARA-Arabic"
                    >
                      {General?.codeLabels["cm_ar"]?.label}
                    </option>
                  </Field>
                  <div style={{ height: "0.5rem" }}>
                    <ErrorMessage
                      name="language"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </Label>
                <Label
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                  }}
                >
                  {General?.codeLabels["cm_pobox"]?.label !== undefined
                    ? General?.codeLabels["cm_pobox"]?.label
                    : "PO Box Number"}
                  *
                  <Field
                    type="number"
                    name="poBoxValue"
                    style={{
                      background: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : "#E5EFF2",
                      color: General.contrast.contrastBackground
                        ? General.contrast.contrastBackground
                        : General?.ColorAss,
                    }}
                    innerRef={poBoxValue}
                  />
                  <div style={{ height: "0.5rem" }}>
                    <ErrorMessage
                      name="poBoxValue"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </Label>
                <Label
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                  }}
                >
                  {General?.codeLabels["cm_emirate"]?.label
                    ? General?.codeLabels["cm_emirate"]?.label
                    : "Emirate"}
                  *
                  <Field
                    as="select"
                    innerRef={emirateValue}
                    name="emirate"
                    style={{
                      background: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : "#E5EFF2",
                      color: General.contrast.contrastBackground
                        ? General.contrast.contrastBackground
                        : General?.ColorAss,
                    }}
                  >
                    <option value={""}>
                      {General?.codeLabels["cm_mob_select"]?.label !== undefined
                        ? General?.codeLabels["cm_mob_select"]?.label
                        : "Select"}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.state == "ABU DH" ? true : false
                      }
                      value="ABU DH"
                    >
                      {General?.codeLabels["cm_abudhabi"]?.label}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.state == "AJMAN" ? true : false
                      }
                      value="AJMAN"
                    >
                      {General?.codeLabels["cm_ajman"]?.label}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.state == "DUBAI" ? true : false
                      }
                      value="DUBAI"
                    >
                      {General?.codeLabels["cm_dubai"]?.label}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.state == "FUJAIR" ? true : false
                      }
                      value="FUJAIR"
                    >
                      {General?.codeLabels["cm_fujairah"]?.label}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.state == "RAS AL" ? true : false
                      }
                      value="RAS AL"
                    >
                      {General?.codeLabels["cm_rasalkhaimah"]?.label}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.state == "SHARJA" ? true : false
                      }
                      value="SHARJA"
                    >
                      {General?.codeLabels["cm_sharjah"]?.label}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.state == "UMM AL" ? true : false
                      }
                      value="UMM AL"
                    >
                      {General?.codeLabels["cm_ummalquwain"]?.label}
                    </option>
                  </Field>
                  <div style={{ height: "0.5rem" }}>
                    <ErrorMessage
                      name="emirate"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </Label>
                <Label
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                  }}
                >
                  {General?.codeLabels["cm_semail"]?.label !== undefined
                    ? General?.codeLabels["cm_semail"]?.label
                    : "Secondary Email Address"}
                  <Field
                    innerRef={alternateEmailValue}
                    name="alternateEmail"
                    type="email"
                    style={{
                      background: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : "#E5EFF2",
                      color: General.contrast.contrastBackground
                        ? General.contrast.contrastBackground
                        : General?.ColorAss,
                    }}
                  />
                  <div style={{ height: "0.5rem" }}>
                    <ErrorMessage
                      name="alternateEmail"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </Label>
                <Label
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                  }}
                >
                  {General?.codeLabels["cm_preffered_delivery_channel"]
                    ?.label !== undefined
                    ? General?.codeLabels["cm_preffered_delivery_channel"]
                        ?.label
                    : "Preferred Service Delivery Channel*"}
                  <Field
                    as="select"
                    name="preferredDeliveryChannel"
                    innerRef={favouriteServiceDeliveryChannelValue}
                    style={{
                      background: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : "#E5EFF2",
                      color: General.contrast.contrastBackground
                        ? General.contrast.contrastBackground
                        : General?.ColorAss,
                    }}
                  >
                    <option value={""}>
                      {General?.codeLabels["cm_mob_select"]?.label !== undefined
                        ? General?.codeLabels["cm_mob_select"]?.label
                        : "Select"}
                    </option>

                    <option value="ASW-Ajman Sewerage website">
                      {General?.codeLabels["cm_website"]?.label !== undefined
                        ? General?.codeLabels["cm_website"]?.label
                        : "Ajman Sewerage website"}
                    </option>

                    <option value="ASMA-Ajman Sewerage mobile App">
                      {General?.codeLabels["cm_mobileapp"]?.label !== undefined
                        ? General?.codeLabels["cm_mobileapp"]?.label
                        : "Ajman Sewerage mobile App"}
                    </option>

                    <option value="ASCC-Ajman Sewerage Contact Center">
                      {General?.codeLabels["cm_contactcen"]?.label !== undefined
                        ? General?.codeLabels["cm_contactcen"]?.label
                        : "Ajman Sewerage Contact Center"}
                    </option>
                    <option value="MAIL-Email">
                      {General?.codeLabels["cm_email"]?.label !== undefined
                        ? General?.codeLabels["cm_email"]?.label
                        : "Email address "}
                    </option>
                    <option value="CHSC-Customer Happiness Service Centres">
                      {General?.codeLabels["cm_payhsc"]?.label !== undefined
                      ? General?.codeLabels["cm_payhsc"]?.label
                      : "Customer Happiness Service Center"}
                    </option>
                  </Field>
                  <div style={{ height: "0.5rem" }}>
                    <ErrorMessage
                      name="preferredDeliveryChannel"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </Label>{" "}
                {/* To Select */}
                <Label
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                  }}
                >
                  {General?.codeLabels["cm_preffered_payment_chanel"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_preffered_payment_chanel"]?.label
                    : "Preferred Payment Channel*"}
                  *
                  <Field
                    as="select"
                    name="prefferedPaymentChannel"
                    innerRef={favouritePaymentChannelValue}
                    style={{
                      background: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : "#E5EFF2",
                      color: General.contrast.contrastBackground
                        ? General.contrast.contrastBackground
                        : General?.ColorAss,
                    }}
                  >
                    <option value={""}>
                      {General?.codeLabels["cm_mob_select"]?.label !== undefined
                        ? General?.codeLabels["cm_mob_select"]?.label
                        : "Select"}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.favouritePaymentChannel?.key ==
                        "PYK"
                          ? true
                          : false
                      }
                      value="PYK-Payment Kiosks"
                    >
                      {General?.codeLabels["cm_paykio"]?.label !== undefined
                        ? General?.codeLabels["cm_paykio"]?.label
                        : "Payment Kiosks"}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.favouritePaymentChannel?.key ==
                        "AAE"
                          ? true
                          : false
                      }
                      value="AAE-Al Ansari Exchange"
                    >
                      {General?.codeLabels["cm_payansari"]?.label !== undefined
                        ? General?.codeLabels["cm_payansari"]?.label
                        : "Al Ansari Exchange"}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.favouritePaymentChannel?.key ==
                        "UAEEX"
                          ? true
                          : false
                      }
                      value="UAEEX-UAE Exchange"
                    >
                      {General?.codeLabels["cm_paysharjahislamicbank"]?.label !== undefined
                        ? General?.codeLabels["cm_paysharjahislamicbank"]?.label
                        : "Sharjah Islamic Bank"}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.favouritePaymentChannel?.key ==
                        "AJBNK"
                          ? true
                          : false
                      }
                      value="AJBNK-Ajman Bank"
                    >
                      {General?.codeLabels["cm_payajmanbank"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_payajmanbank"]?.label
                        : "Ajman Bank"}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.favouritePaymentChannel?.key ==
                        "DXBIB"
                          ? true
                          : false
                      }
                      value="DXBIB-Dubai Islamic Bank"
                    >
                      {General?.codeLabels["cm_paydib"]?.label !== undefined
                        ? General?.codeLabels["cm_paydib"]?.label
                        : "Dubai Islamic Bank"}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.favouritePaymentChannel?.key ==
                        "ENBD"
                          ? true
                          : false
                      }
                      value="ENBD-Emirates NBD"
                    >
                      {General?.codeLabels["cm_payendb"]?.label !== undefined
                        ? General?.codeLabels["cm_payendb"]?.label
                        : "Emirates NBD"}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.favouritePaymentChannel?.key ==
                        "CASH"
                          ? true
                          : false
                      }
                      value="CASH-Cash Deposit"
                    >
                      {General?.codeLabels["cm_paycash"]?.label !== undefined
                        ? General?.codeLabels["cm_paycash"]?.label
                        : "Cash Deposit"}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.favouritePaymentChannel?.key ==
                        "CHQ"
                          ? true
                          : false
                      }
                      value="CHQ-Cheque Deposit"
                    >
                      {General?.codeLabels["cm_paycheque"]?.label !== undefined
                        ? General?.codeLabels["cm_paycheque"]?.label
                        : "Cheque Deposit"}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.favouritePaymentChannel?.key ==
                        "ONLN"
                          ? true
                          : false
                      }
                      value="ONLN-Online"
                    >
                      {General?.codeLabels["cm_payonline"]?.label !== undefined
                        ? General?.codeLabels["cm_payonline"]?.label
                        : "Online"}
                    </option>
                    <option selected={
                        General?.otpUserData?.favouritePaymentChannel?.key ==
                        "CHSC"
                          ? true
                          : false
                      }
                      value="CHSC-Customer Happiness Service Centres">
                     {General?.codeLabels["cm_payhsc"]?.label !== undefined
                      ? General?.codeLabels["cm_payhsc"]?.label
                      : "Customer Happiness Service Center"}
                    </option>
                  </Field>
                  <div style={{ height: "0.5rem" }}>
                    <ErrorMessage
                      name="prefferedPaymentChannel"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </Label>
                {!owner && (
                  <Label
                    style={{
                      color: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : General?.ColorAss,
                      fontFamily: "Segoe UI",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      lineHeight: "16px",
                      gap: "0.5rem",
                    }}
                  >
                    {General?.codeLabels["cm_tced"]?.label !==
                    undefined
                      ? General?.codeLabels["cm_tced"]?.label
                      : "Tenancy / Contract Expiry Date*"}
                    *
                    <Field
                      name="tenancyDate"
                      min={new Date().toISOString().split("T")[0]}
                      innerRef={tenancyContractExpiryDateValue}
                      type="date"
                      defaultValue={defaultDateContract}
                      placeholder="dd-mm-yyyy"
                      style={{
                        background: General.contrast.contrastColor
                          ? General.contrast.contrastColor
                          : "#E5EFF2",
                        color: General.contrast.contrastBackground
                          ? General.contrast.contrastBackground
                          : General?.ColorAss,
                      }}
                    />
                    <div style={{ height: "0.5rem" }}>
                      <ErrorMessage
                        name="tenancyDate"
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </Label>
                )}
                {/* To Date Picker */}
                <Label
                  style={{
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                  }}
                >
                  {General?.codeLabels["cm_preffered_communication"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_preffered_communication"]?.label
                    : "Preferred Time of Communication*"}
                  <div
                    style={{
                      display: "flex",
                      width: "75%",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <Field
                        className="inputRadio1"
                        type="checkBox"
                        name={"morningValue"}
                        defaultChecked={General?.otpUserData?.morning}
                        onChange={() =>
                          setFieldValue("morningValue", !values.morningValue)
                        }
                        innerRef={morningValue}
                        style={{
                          accentColor: "#62AA51",
                          background: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : "",
                          color: General.contrast.contrastColor
                            ? General.contrast.contrastColor
                            : General?.ColorAss,
                          width: "15px",
                        }}
                      />
                      <p
                        style={{
                          color: General.contrast.contrastColor
                            ? General.contrast.contrastColor
                            : General?.ColorAss,
                          marginTop: "1rem",
                          marginLeft: "0.5rem",
                          marginRight:
                            General?.codeLabels["cm_pdc_paymentaccounts"]
                              ?.languageCode == "ARA"
                              ? "0.5rem"
                              : "",
                        }}
                      >
                        {General?.codeLabels["cm_morning"]?.label !== undefined
                          ? General?.codeLabels["cm_morning"]?.label
                          : "Morning"}
                      </p>
                    </div>
                    <div style={{ display: "flex" }}>
                      <Field
                        className="inputRadio1"
                        type="checkBox"
                        name={"afternoonValue"}
                        onChange={() =>
                          setFieldValue(
                            "afternoonValue",
                            !values.afternoonValue
                          )
                        }
                        defaultChecked={General?.otpUserData?.afternoon}
                        style={{
                          accentColor: "#62AA51",
                          background: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : "",
                          color: General.contrast.contrastColor
                            ? General.contrast.contrastColor
                            : General?.ColorAss,
                          width: "15px",
                        }}
                        innerRef={afternoonValue}
                      />
                      <p
                        style={{
                          color: General.contrast.contrastColor
                            ? General.contrast.contrastColor
                            : General?.ColorAss,
                          marginTop: "1rem",
                          marginLeft: "0.5rem",
                          marginRight:
                            General?.codeLabels["cm_pdc_paymentaccounts"]
                              ?.languageCode == "ARA"
                              ? "0.5rem"
                              : "",
                        }}
                      >
                        {General?.codeLabels["cm_afternoon"]?.label !==
                        undefined
                          ? General?.codeLabels["cm_afternoon"]?.label
                          : "Afternoon"}
                      </p>
                    </div>

                    <div style={{ display: "flex" }}>
                      <Field
                        style={{
                          accentColor: "#62AA51",
                          background: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : "",
                          color: General.contrast.contrastColor
                            ? General.contrast.contrastColor
                            : General?.ColorAss,
                          width: "15px",
                        }}
                        className="inputRadio3"
                        type="checkBox"
                        onChange={() =>
                          setFieldValue("eveningValue", !values.eveningValue)
                        }
                        defaultChecked={General?.otpUserData?.evening}
                        name={"eveningValue"}
                        innerRef={eveningValue}
                      />
                      <p
                        style={{
                          color: General.contrast.contrastColor
                            ? General.contrast.contrastColor
                            : General?.ColorAss,
                          marginTop: "1rem",
                          marginLeft: "0.5rem",
                          marginRight:
                            General?.codeLabels["cm_pdc_paymentaccounts"]
                              ?.languageCode == "ARA"
                              ? "0.5rem"
                              : "",
                        }}
                      >
                        {General?.codeLabels["cm_evening"]?.label !== undefined
                          ? General?.codeLabels["cm_evening"]?.label
                          : "Evening"}
                      </p>
                    </div>
                  </div>
                  <div style={{ height: "0.5rem" }}>
                    <ErrorMessage
                      name="eveningValue"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </Label>{" "}
                <Label></Label>
              </InfoContainer>
              <>
                <TabContainer>
                  {(showEmirates || showTenancy) && (
                    <h3
                      style={{
                        color: General.contrast.contrastColor
                          ? General.contrast.contrastColor
                          : General?.ColorAss,
                      }}
                    >
                      {General?.codeLabels["cm_nocmandatoryattachments"]?.label}
                    </h3>
                  )}
                  {showTenancy && (
                    <Label
                      style={{
                        color: General.contrast.contrastColor
                          ? General.contrast.contrastColor
                          : General?.ColorAss,
                        fontFamily: "Segoe UI",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: `${General.accessibility.fontSize}rem`,
                        lineHeight: "16px",
                        gap: "0.5rem",
                        width: General?.isLargeScreen ? "50%" : "100%",
                      }}
                    >
                      <Document
                        exists={false}
                        mainText={
                          General?.codeLabels["cm_copy_tenancy"]?.label !==
                          undefined
                            ? General?.codeLabels["cm_copy_tenancy"]?.label
                            : "Copy of Tenant Contract"
                        }
                        subText={
                          General?.codeLabels["cm_mandatory_document"]
                            ?.label !== undefined
                            ? General?.codeLabels["cm_mandatory_document"]
                                ?.label
                            : "Mandatory Document"
                        }
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleUploadFileChange(e, "tenantContractFile") }}
                        inputName={"tenantContractFile"}
                      />
                      {fileErrors["tenantContractFile"] && <p
                        style={{
                        color: "red",
                        margin: "4px 0 0 0",
                        fontWeight: "bold",
                        }}
                        >
                        {General?.codeLabels["cm_nofileerr"]?.label
                        ? General?.codeLabels["cm_nofileerr"]?.label
                        : "Please uploadType Here"}{" "}
                        {
                          General?.codeLabels["cm_copy_tenancy"]
                          .label
                        }
                        </p>}
                    </Label>
                  )}
                  {showEmirates && (
                    <Label
                      style={{
                        color: General.contrast.contrastColor
                          ? General.contrast.contrastColor
                          : General?.ColorAss,
                        fontFamily: "Segoe UI",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: `${General.accessibility.fontSize}rem`,
                        lineHeight: "16px",
                        gap: "0.5rem",
                        width: General?.isLargeScreen ? "50%" : "100%",
                      }}
                    >
                      <Document
                        exists={false}
                        mainText={bType?General?.codeLabels["cm_attachment6"]?.label:
                          General?.codeLabels["cm_emirate_id_doc"]?.label !==
                          undefined
                            ? General?.codeLabels["cm_emirate_id_doc"]?.label
                            : "Copy of Emirates ID"
                        }
                        subText={
                          General?.codeLabels["cm_mandatory_document"]
                            ?.label !== undefined
                            ? General?.codeLabels["cm_mandatory_document"]
                                ?.label
                            : "Mandatory Document"
                        }
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleUploadFileChange(e, bType ? "tradeLicenseFile" : "emiratesIDFile") }}
                        inputName={bType ? "tradeLicenseFile" : "emiratesIDFile"}
                      />
                      {!bType && fromUaePass != "uaePassLogin" && (
                      <div
                  style={{
                    marginTop: "8px",
                    marginBottom: "8px",
                    fontSize: "0.85rem",
                    color: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss,
                    background: contrast?.contrastBackground ? contrast?.contrastBackground : "transparent",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  {(() => {
                    const label = General?.codeLabels["cm_attachment3"]?.label;
                    if (label) {
                      // replace <br> with newline and move text after '*' to the next line (remove the '*'), collapse multiple newlines and trim
                      const cleaned = label
                        .replace(/<br\s*\/?>/gi, "\n")
                        .replace(/\*\s*/g, "\n")
                        .replace(/\n{2,}/g, "\n")
                        .trim();
                      return cleaned;
                    }
                    return "*If the EID is expired, please attach the renewal application form as well.";
                  })()}
                </div>
                )}
                      {fileErrors[bType ? "tradeLicenseFile" : "emiratesIDFile"] && <p
                        style={{
                        color: "red",
                        margin: "4px 0 0 0",
                        fontWeight: "bold",
                        }}
                        >
                        {General?.codeLabels["cm_nofileerr"]?.label
                        ? General?.codeLabels["cm_nofileerr"]?.label
                        : "Please uploadType Here"}{" "}
                        {
                          bType ? General?.codeLabels["cm_attachment6"]?.label : General?.codeLabels["cm_emirate_id_doc"]
                          .label
                        }
                        </p>}
                    </Label>
                  )}
                 {fromUaePass != "uaePassLogin" && (

                
                  <div
                    style={{
                      border: `1px solid ${ contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : ""}`,
                      textAlign: "center",
                      cursor: "pointer",
                      display: "inline-block",
                      height: "25px",
                      fontFamily: "Segoe UI",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: "14px",
                      lineHeight: "20px",
                      textTransform: "uppercase",
                      background: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "",
                      color: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : "",
                      width: General?.isLargeScreen ? "210px" : "100%",
                    }}
                    onClick={handleAddOptionalDocument}
                  >
                    {General?.codeLabels["cm_add_attachment"]?.label !==
                    undefined
                      ? General?.codeLabels["cm_add_attachment"]?.label
                      : "Add Document"}
                  </div>
                  )}
                 
                  {optionalUploadedFiles.map((optionalFile: OptionalFile) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        style={{
                          width: General?.isLargeScreen ? "50%" : "90%",
                        }}
                      >
                        <Document
                          exists={false}
                          mainText={optionalFile.name}
                          subText={
                            General?.codeLabels["cm_optional_document"]
                              ?.label !== undefined
                              ? General?.codeLabels["cm_optional_document"]
                                  ?.label
                              : "Optional Document"
                          }
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleUploadFileChange(e, optionalFile.name) }}
                          inputName={optionalFile.name}
                        />
                      </div>
                      <div style={{ marginRight: "1rem" }}>
                        <button
                          type="button"
                          style={{
                            cursor: "pointer",
                            background: "none",
                            border: 0,
                          }}
                          onClick={() =>
                            handleRemoveOptionalDocument(optionalFile.id)
                          }
                        >
                          <img
                            src={trashIcon}
                            alt="Remove Optional Attachment"
                          />
                        </button>
                      </div>
                    </div>
                  ))}
                </TabContainer>
              </>

              {fromUaePass != "uaePassLogin" && (
                <>
                  <h3
                    style={{
                      fontFamily: "Segoe UI",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: "25px",
                      lineHeight: "32px",
                      color: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : General?.ColorAss,
                    }}
                  >
                    {General?.codeLabels["cm_login_creds"]?.label !== undefined
                      ? General?.codeLabels["cm_login_creds"]?.label
                      : "User / Login Credentials"}
                  </h3>
                  <InfoContainer
                    style={{
                      gridTemplateColumns: General?.isLargeScreen ? "" : "1fr",
                    }}
                  >
                    <Label
                      style={{
                        color: General.contrast.contrastColor
                          ? General.contrast.contrastColor
                          : General?.ColorAss,
                        fontFamily: "Segoe UI",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: `${General.accessibility.fontSize}rem`,
                        lineHeight: "16px",
                        gap: "0.5rem",
                      }}
                    >
                      {General?.codeLabels["cm_select_user_name"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_select_user_name"]?.label
                        : "Select Username"}
                      *
                      <Field
                        onBlur={(e: any) => validateUserName(e.target.value)}
                        innerRef={userNameValue}
                        name="userNameValue"
                        type="text"
                        style={{
                          background: General.contrast.contrastColor
                            ? General.contrast.contrastColor
                            : "#E5EFF2",
                          color: General.contrast.contrastBackground
                            ? General.contrast.contrastBackground
                            : General?.ColorAss,
                        }}
                      />
                      <div style={{ height: "0.5rem" }}>
                        {invalidUsername ? (
                          <span
                            style={{
                              color: General.contrast.contrastColor
                                ? General.contrast.contrastColor
                                : "red",
                            }}
                          >
                            {invalidUsername}
                          </span>
                        ) : null}
                      </div>
                      {isUserNameUnique ? (
                        <span
                          style={{
                            color: General.contrast.contrastColor
                              ? General.contrast.contrastColor
                              : "red",
                          }}
                        >
                          {General?.codeLabels["cm_otp_uname_unavailable"]
                            ?.label !== undefined
                            ? General?.codeLabels["cm_otp_uname_unavailable"]
                                ?.label
                            : "Sorry, the username already exists. Please try another one"}
                        </span>
                      ) : null}
                    </Label>
                    <Label></Label>
                    <Label
                      style={{
                        color: General.contrast.contrastColor
                          ? General.contrast.contrastColor
                          : General?.ColorAss,
                        fontFamily: "Segoe UI",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: `${General.accessibility.fontSize}rem`,
                        lineHeight: "16px",
                        gap: "0.5rem",
                      }}
                    >
                      {General?.codeLabels["cm_create_password"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_create_password"]?.label
                        : "Create Password"}
                      *
                      <Field
                        innerRef={passwordValue}
                        name="password"
                        type="password"
                        style={{
                          background: General.contrast.contrastColor
                            ? General.contrast.contrastColor
                            : "#E5EFF2",
                          color: General.contrast.contrastBackground
                            ? General.contrast.contrastBackground
                            : General?.ColorAss,
                        }}
                        placeholder={
                          General?.codeLabels["cm_passwordhint"]?.label !==
                          undefined
                            ? General?.codeLabels["cm_passwordhint"]?.label
                            : "Minimum 8 Characters"
                        }
                        onBlur={(e: any) => validatePassword(e.target.value)}
                      />
                      <div style={{ height: "2rem" }}>
                        <span style={{ color: "red" }}> {isValidPassword}</span>
                      </div>
                    </Label>
                    <Label
                      style={{
                        color: General.contrast.contrastColor
                          ? General.contrast.contrastColor
                          : General?.ColorAss,
                        fontFamily: "Segoe UI",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: `${General.accessibility.fontSize}rem`,
                        lineHeight: "16px",
                        gap: "0.5rem",
                      }}
                    >
                      {General?.codeLabels["cm_cpassword"]?.label !== undefined
                        ? General?.codeLabels["cm_cpassword"]?.label
                        : "Confirm Password"}{" "}
                      *
                      <Field
                        innerRef={confirmPasswordValue}
                        onBlur={(e: any) =>
                          validateConfirmPassword(e.target.value)
                        }
                        name="conformPassword"
                        type="password"
                        style={{
                          background: General.contrast.contrastColor
                            ? General.contrast.contrastColor
                            : "#E5EFF2",
                          color: General.contrast.contrastBackground
                            ? General.contrast.contrastBackground
                            : General?.ColorAss,
                        }}
                      />
                      <div style={{ height: "2rem" }}>
                        <span style={{ color: "red" }}> {isMatchPassword}</span>
                      </div>
                    </Label>
                  </InfoContainer>
                </>
              )}
              {/* <br /> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                  marginTop: "2rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <Field
                    // onChange={()=>setacceptTerms(true)}
                    style={{ width: "20px", height: "20px" }}
                    name="toggle"
                    type="checkbox"
                  />
                  <label
                    style={{
                      fontFamily: "Segoe UI",
                      fontStyle: "normal",
                      fontWeight: "400",
                      fontSize: `${General.accessibility.fontSize}rem`,
                      lineHeight: "20px",
                      paddingTop:"4px",
                      color: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : General?.ColorAss,
                    }}
                  >
                    <span style={{marginTop:"2px"}} dangerouslySetInnerHTML={{
                      __html: (General?.codeLabels["cm_user_consent_msg"]?.label !== undefined
                        ? General?.codeLabels["cm_user_consent_msg"]?.label 
                        : "I accept all")
                    }} />
                    {/* <b
                      style={{
                        color: General.contrast.contrastColor
                          ? General.contrast.contrastColor
                          : General?.ColorAss,
                      }}
                    >
                      &nbsp;
                      <span
                        onClick={() =>
                          window.open(
                            `${constants?.URL?.CORPORATE_WEBSITE}home/privacypolicy`,
                            "_blank"
                          )
                        }
                        style={{
                          cursor: "pointer",
                          color: General.contrast.contrastColor
                            ? General.contrast.contrastColor
                            : General?.ColorAss,
                        }}
                      >
                        {General?.codeLabels["cm_terms_cond"]?.label !==
                        undefined
                          ? General?.codeLabels["cm_terms_cond"]?.label
                          : "Terms & Conditions"}
                      </span>
                    </b> */}
                  </label>
                </div>
                <hr style={{ width: "100%" }} />
              </div>

              <ButtonsContainer
                style={{
                  justifyContent: "start",
                  gap: "2.5rem",
                  flexDirection: General?.isLargeScreen ? "row" : "column",
                  width: General?.isLargeScreen ? "" : "100%",
                }}
              >
                <ButtonSecondary
                  style={{
                    width: General?.isLargeScreen ? "163px" : "100%",
                    height: "50px",
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "20px",
                    padding: "auto",
                    background: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "",
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "",
                  }}
                  onClick={Previous}
                >
                  {General?.codeLabels["cm_back"]?.label !== undefined
                    ? General?.codeLabels["cm_back"]?.label
                    : "BACK"}
                </ButtonSecondary>
                <ButtonSecondary
                  disabled={!values.toggle}
                  type="submit"
                  onClick={()=>{validate() }}
                  style={{
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "20px",
                    width: General?.isLargeScreen ? "228px" : "100%",
                    height: "50px",
                    padding: "10px",
                    background: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "#101e8e",
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "#fff",
                    opacity: values.toggle ? "1" : "0.5",
                  }}
                >
                  {registerLoader ? (
                    <Spinner width="30px" height="30px" />
                  ) : !owner && User?.profile?.personId ? (
                    General?.codeLabels["cm_attach_movein"]?.label !==
                    undefined ? (
                      General?.codeLabels["cm_attach_movein"]?.label
                    ) : (
                      "Attach & MoveIn"
                    )
                  ) : General?.codeLabels["cm_submit_and_rgister"]?.label !==
                    undefined ? (
                    General?.codeLabels["cm_submit_and_rgister"]?.label
                  ) : (
                    "SUBMIT & REGISTER"
                  )}
                </ButtonSecondary>
              </ButtonsContainer>
            </Form>
          )}
        </Formik>
      </TabContainer>
    </>
  );
};
export default Info;
